export default {
  // httpPrefix: "/tenant-plant-backend",
  // httpSim: "/tenant-juno-sim-v3",
  httpPrefix: "/tenant-plant-backend",
  httpSim: "/tenant-juno-sim-v3",
  tenantHttpPrefix: "/tenant-upms-provider",
  manageHttpPrefix: "/management-upms-provider",
  modelKeeperPrefix: "/tenant-model-keeper",
  apiTest: "/api-test",
  // sysCode: "APP187595770956873728", // 测试环境
  sysCode: "APP201253579527290880", // 线上免费版
  rules: ({ type, maxLength = 30, trigger = "blur", message }) => {
    const rules = {
      required: {
        required: true,
        message: message || "不能为空",
        trigger,
      },
      unnecessary: {
        required: false,
        message: message || "不能为空",
        trigger,
      },
      maxLength: {
        max: maxLength,
        message: message || `最多输入${maxLength}个字符`,
        trigger,
      },
      phone: {
        pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
        message: "请输入正确格式的手机号",
        trigger,
      },
      intrger: {
        pattern: /^-?[1-9]\d*$/,
        message: "请输入整数",
        trigger,
      },
      integer1: {
        pattern: /^[0-9]\d*$/,
        message: "请填写非负整数",
        trigger,
      },
      positiveInteger: {
        pattern: /^[1-9]\d*$/,
        message: "请输入正整数",
        trigger,
      },
      long: {
        pattern: /^(-?\d+)(\.\d+)?$/,
        message: "请填写正确的数值",
        trigger,
      },
      long2: {
        pattern: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/,
        message: message || "保留两位小数",
      },
      long6: {
        pattern: /(^[1-9]\d*(\.\d{1,6})?$)|(^0(\.\d{1,6})?$)/,
        message: message || "最多保留6位小数",
      },
      price: {
        pattern: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/,
        message: message || "请输入正确的金额",
      },
      space: {
        pattern: /^\S*$/,
        message: "请勿输入空格",
        trigger,
      },
      code: {
        pattern: /^[A-Za-z0-9]+$/,
        message: message || "编码由数字或者英文字母组成",
        trigger,
      },
      code1: {
        pattern: /^[^\u4e00-\u9fa5]+$/,
        message: message || "编码不能包含汉字",
        trigger,
      },
      link: {
        pattern: /^(http|https):\/\/([\w.]+\/?)\S*/,
        message: message || "请输入正确的地址",
        trigger,
      },
      idCard: {
        pattern:
          /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
        message: "请输入正确身份证号",
        trigger,
      },
      version: {
        pattern: /^\d+(?:\.\d+){1,3}(?:\.\d+)?$/,
        message: "请输入正确的版本号",
        trigger
      }
    };

    return rules[type];
  },
};
